import { CSSProperties } from 'react';
import { HeaderSubLabel, SubColumnSortLabels } from './subColumns';

import styles from './RenderCell.module.css';

interface RenderHeaderProps {
	/** Text to display in the Column Header */
	primaryText?: string;
	/** Description of the secondary slot data */
	secondaryText?: string;
	/** Structured sub-value labels rendered instead of secondaryText; entries whose companion sort column is registered become sort targets */
	subLabels?: HeaderSubLabel[];
	/** Title text to display over Column Header when needed */
	title?: string;
	/** Inline styles for rendering specific look & feel for mobile virtualized list */
	style?: CSSProperties;
}

/**
 * Component for rendering Grid Column Header Cells
 */
export default function RenderHeader(props: RenderHeaderProps) {
	return (
		<div
			className={`${styles['header-cell']} ${styles.ellipsis}`}
			style={props.style}
			title={props.title}
		>
			<span className={`${styles['header-primary']} ${styles.bold}`}>{props.primaryText}</span>

			{props.subLabels?.length ? (
				<div className={`${styles.ellipsis} ${styles['header-secondary']}`}>
					<SubColumnSortLabels labels={props.subLabels} />
				</div>
			) : (
				props.secondaryText && (
					<div className={`${styles.ellipsis} ${styles['header-secondary']}`}>
						<span className={styles['secondary-text']}>{props.secondaryText}</span>
					</div>
				)
			)}
		</div>
	);
}
